import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

// Big editorial statement whose lines "ink in" with gradient as you scroll.
const LINES = [
  { text: 'From scruffy to fluffy.', italic: false },
  { text: 'From nervous to napping.', italic: true },
  { text: 'From walk-in to work of art.', italic: false },
];

function Line({ text, italic }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start 0.9', 'start 0.45'] });
  const clip = useTransform(scrollYProgress, [0, 1], ['inset(0 100% 0 0)', 'inset(0 0% 0 0)']);

  return (
    <div ref={ref} className="relative leading-[1.08]">
      <p className={`font-display font-black tracking-tight text-[7.4vw] sm:text-5xl md:text-6xl lg:text-7xl text-ink-900/[0.12] ${italic ? 'italic' : ''}`}>
        {text}
      </p>
      <motion.p
        style={{ clipPath: clip }}
        aria-hidden
        className={`absolute inset-0 font-display font-black tracking-tight text-[7.4vw] sm:text-5xl md:text-6xl lg:text-7xl bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 bg-clip-text text-transparent ${italic ? 'italic' : ''}`}
      >
        {text}
      </motion.p>
    </div>
  );
}

export default function Statement() {
  return (
    <section className="py-24 md:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-4 space-y-3 md:space-y-5 text-center lg:text-left">
        {LINES.map((l) => <Line key={l.text} {...l} />)}
      </div>
    </section>
  );
}
